import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Pagination, Row, Col, Space } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Loading, Page, Panel, Total } from '../../../../../../../components'
import { BreadcrumbSystem as Breadcrumb, OrgPermission } from '../../../../../../../constants'
import { platformAdminRoleService } from '../../../../../../../services'
import { auth, localStorage, validator } from '../../../../../../../util'
import { SysStore } from '../../../../../../../stores'

import 'antd/dist/antd.css'
import './styles.css'

const pageSize = 20

const columns = (platformId) => ([
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 8
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 11
  },
  {
    width: 2,
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    render: (active) => active === true
      ? <CheckCircleOutlined style={{color: '#4fbc85', fontSize: '14pt'}} />
      : <CloseCircleOutlined style={{color: '#ccc', fontSize: '14pt'}} />
  },
  {
    width: 3,
    render: (item) => <Space size='middle'>
      { hasAccess(OrgPermission.SOFTWARE.USER_ROLE.READ)
        ? <Link to={`/software/detail/${platformId}/roles/${item.id}`} key={`rolekey${item.id}`}>
          <FormOutlined />
        </Link>
        : null }

    </Space>
  },
])

const hasAccess = (permission) => {
  return auth.hasAccess(permission)
}

function PortalUserRoleList (props) {
  const platformId = props.platformId
  const [isLoading, setIsLoading] = useState(false)
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({ active: true, platform_id: platformId })
  const [sort, setSort] = useState({})

  useEffect(() => {
    fetchList({ currentPage: 1 })
  }, [])

  async function fetchList ({ currentPage = page }) {
    if (!hasAccess(OrgPermission.SOFTWARE.USER_ROLE.LIST)) return

    let showMode = auth.getMode()
    setIsLoading(true)

    // filter.org_id = [0, parseInt(showMode)]
    filter.org_id = parseInt(showMode)
    const r = await platformAdminRoleService.orgListByPage(currentPage, pageSize, filter, sort)

    if (r && r.list) {
      setIsLoading(false)
      setList(r.list)
      setPage(currentPage)
      setTotal(r.total)
    }
  }

  return (
    <div>
      <Page.Header title='User Roles'>
        { hasAccess(OrgPermission.SOFTWARE.USER_ROLE.CREATE)
          ? <Link to={`/software/detail/${platformId}/roles/add`}>
            <Button shape='round' type='primary'>Add User Role</Button>
          </Link>
          : null }

      </Page.Header>

      <Page.Content>
        <Table
          loading={isLoading}
          columns={columns(platformId)}
          dataSource={list}
          size='small'
          rowKey={(itm) => (`rolels${itm.id}`)}
          pagination={{
            hideOnSinglePage: true,
            pageSize,
            total,
            onChange: (e) => fetchList({currentPage: e})
          }}
        />
        <Total total={total} title={'role'} />
      </Page.Content>
    </div>
  )
}

export default PortalUserRoleList
